/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function UnpublishIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "unpublish", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M5 19.5H20", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 16L12.5 4.99999", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M17.5 11L12.5 16L7.49998 11", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(UnpublishIcon);
export default ForwardRef;
//# sourceMappingURL=unpublishIcon.js.map